module.exports = __webpack_public_path__ + "img/file-1561138874932.36c16976.jpeg";